import { createApp } from 'vue';
import PhotoSwipeComponent from './PhotoSwipe.vue';
export default class PhotoSwipe {
    constructor() {
        const div = document.createElement('div');
        document.body.appendChild(div);
        this.$vm = createApp(PhotoSwipeComponent).mount(div);
    }
    open(event, index) {
        this.$vm.open(event, index);
    }
    close() {
        this.$vm.close();
    }
}
